import { render, staticRenderFns } from "./button.vue?vue&type=template&id=bc0bb38a&scoped=true&"
import script from "./button.vue?vue&type=script&lang=js&"
export * from "./button.vue?vue&type=script&lang=js&"
import style0 from "./button.vue?vue&type=style&index=0&id=bc0bb38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0bb38a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc0bb38a')) {
      api.createRecord('bc0bb38a', component.options)
    } else {
      api.reload('bc0bb38a', component.options)
    }
    module.hot.accept("./button.vue?vue&type=template&id=bc0bb38a&scoped=true&", function () {
      api.rerender('bc0bb38a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vab/form/button.vue"
export default component.exports